import { render, staticRenderFns } from "./_jdbGtf.vue?vue&type=template&id=c28b0570&lang=pug&"
import script from "./_jdbGtf.vue?vue&type=script&lang=js&"
export * from "./_jdbGtf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports